<template>
    <div class="Practice">
        <ScenarioItem
            v-for="(journey, i) of journeyStepsThatHasScenarios"
            :key="journey.id"
            class="ScenarioItem"
            :use-ellipsis="useEllipsis"
            :hide-activities="hideActivities"
            :journey="journey"
            :course-id="courseId"
            :did-user-scenario-today="didUserScenarioToday"
            :is-current-journey="i === currentJourneyIndex"
        />
    </div>
</template>

<script>
import scrollparent from '@/scrollparent';
import ScenarioItem from './ScenarioItem';
import { mapGetters } from 'vuex';

export default {
    components: { ScenarioItem },
    props: {
        courseId: {
            type: String
        },
        useEllipsis: {
            type: Boolean,
            default: false
        },
        hideActivities: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            collapseMap: {},
            expandedJourneyId: null,
            scrollToStep: null,
            courseTimestampsArray: [],
            collapsed: true
        };
    },

    computed: {
        ...mapGetters({
            getJourneyById: 'moduleCourse/getJourneyById',
            getStepById: 'moduleCourse/getStepById',
            getScenarioById: 'moduleCourse/getScenarioById'
        }),

        course() {
            return this.$store.state.moduleCourse.courses[this.courseId];
        },

        courseStepGroups() {
            return this.course.stepGroupIds.map(id => this.getJourneyById(id));
        },

        journeyStepsThatHasScenarios() {
            return this.courseStepGroups.filter(stepGroup =>
                stepGroup.stepIds.some(stepId => this.getStepById(stepId).scenarioIds)
            );
        },

        courseStats() {
            return this.$store.getters['moduleCourse/getCourseStats'](this.courseId);
        },

        items() {
            return [
                {
                    title: 'title',
                    align: 'center',
                    text: 'text',
                    progress: 0
                },
                {
                    title: 'title',
                    align: 'center',
                    text: 'text',
                    progress: 0
                },
                {
                    title: 'title',
                    align: 'center',
                    text: 'text',
                    progress: 0
                }
            ];
        },

        courseTimestamps() {
            return this.journeyStepsThatHasScenarios.map(stepGroup =>
                stepGroup.stepIds.map(stepId => {
                    const scenarioIds = this.getStepById(stepId).scenarioIds;

                    if (scenarioIds) {
                        return scenarioIds.map(scenarioId => this.getScenarioById(scenarioId).timestamp);
                    }
                })
            );
        },

        didUserScenarioToday() {
            return this.courseTimestampsArray.some(timestamp => this.isToday(timestamp));
        },

        currentJourneyIndex() {
            return this.course.currentScenarioInfo?.habitJourneyIndex;
        }
    },

    created() {
        const lastStepId = this.$store.state.moduleCourse.otherStuff.lastStepId;
        this.$store.commit('moduleCourse/setLastStepId', { stepId: null });
        const lastJourneyId = this.$store.state.moduleCourse.otherStuff.lastJourneyId;
        this.$store.commit('moduleCourse/setLastJourneyId', { journeyId: null });
        this.setCourseTimestamps();

        if (lastStepId) {
            const step = this.$store.state.moduleCourse.steps[lastStepId];
            if (step) {
                if (this.course.stepGroupIds.indexOf(step.stepGroupId) !== -1) {
                    this.scrollToStep = lastStepId;
                    this.expandedJourneyId = step.stepGroupId;
                    return;
                }
            }
        } else if (lastJourneyId) {
            this.scrollToStep = 'QUIZ';
            this.expandedJourneyId = lastJourneyId;
            return;
        }

        const courseStats = this.$store.getters['moduleCourse/getCourseStats'](this.courseId);
        if (courseStats.firstActiveJourneyId || courseStats.firstActiveStepId) {
            this.expandedJourneyId = courseStats.firstActiveJourneyId;
        }
    },

    async mounted() {
        if (this.scrollToStep) {
            const scrollContainer = scrollparent(this.$el);

            if (scrollContainer) {
                let adjust = 14;
                if (scrollContainer.__vue__) {
                    const stickyHeight = scrollContainer.__vue__.stickyHeight();
                    adjust += stickyHeight;
                }
                const y1 = scrollContainer.getBoundingClientRect().top;
                const elem =
                    this.scrollToStep === 'QUIZ'
                        ? this.$el.querySelector('.JourneyQuizItem')
                        : this.$el.querySelector(`.StepItem[data-step-id="${this.scrollToStep}"]`);
                const y2 = elem.getBoundingClientRect().top;

                scrollContainer.scrollTop = y2 - y1 - adjust;
            }
        }
    },

    methods: {
        isToday(timestamp) {
            const today = new Date();
            const scenarioDoneDate = new Date(parseInt(timestamp));

            return (
                scenarioDoneDate.getDate() === today.getDate() &&
                scenarioDoneDate.getMonth() === today.getMonth() &&
                scenarioDoneDate.getFullYear() === today.getFullYear()
            );
        },

        setCourseTimestamps() {
            this.courseTimestamps.forEach(stepGroupTimestamps =>
                stepGroupTimestamps.forEach(
                    stepTimestamps =>
                        stepTimestamps &&
                        stepTimestamps.forEach(timestamp => timestamp && this.courseTimestampsArray.push(timestamp))
                )
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.Practice {
    @media (max-width: 884px) {
        margin-right: 0;
    }
}
.ScenarioItem {
    &:not(:first-child) {
        margin-top: 1em;
    }
}
</style>
